<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="query['owner.id']" :options="owners" placeholder="placeholder.owner" @change="refresh"/>
        <vxe-input v-model="query['no']" placeholder="placeholder.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['customer.name']" placeholder="placeholder.supplierName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.no']" placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="query.range" clearable linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
        <vxe-column field="order.no" sortable title="business.label.orderNo" width="120"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderStatus}" field="order.orderStatus" title="business.label.orderStatus" width="100"/>
        <vxe-column field="owner.name" title="business.label.owner" width="200"/>
        <vxe-column field="customer.name" title="business.label.supplier" width="400"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.detail" icon="vxe-icon-association-form" status="primary" @click.stop="getDetail(row)"/>
            <vxe-button :disabled="row.order.orderStatus>=1" content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="getDetail(row)"/>
            <vxe-button :disabled="row.order.orderStatus>1" content="button.cancel" icon="vxe-icon-undo" status="danger" @click.stop="cancel(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll, post } from '@/api/Api'
import moment from 'moment'
import api from '@/api'

export default {
  name: 'AsnQuery',
  props: {
    orderStatus: { type: Array, default: [] },
    owners: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'no': '',
        'owner.id': undefined,
        'customer.name': '',
        'item.no': '',
        refundable: false,
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    moment,
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args['owner.id']) {
        args['owner.ids'] = [args['owner.id']]
      }
      if (args.range.length !== 0) {
        args['dateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['dateFilter'] = null
      }
      findAll('receivingAsnListFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'no': '',
        'owner.id': undefined,
        'customer.name': '',
        'item.no': '',
        refundable: false,
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    },
    getDetail(row) {
      this.$emit('getDetail', row)
    },
    add() {
      this.$emit('add')
    },
    cancel(row) {
      const that = this
      this.$confirm({
        title: '取消后此单据作废,需重新制单',
        content: '是否确定取消',
        onOk() {
          that.loading = true
          post(api.receivingAsnCancel, { type: 'normalAsn' }, { id: row.order.id }).then(res => {
            if (res.success) {
              that.fetch()
              that.$message.success(this.$t('message.operationSuccess'))
            }
          }).finally(() => that.loading = false)
        },
        onCancel() {
        },
        centered: true
      })
    }
  }
}
</script>